export type LogoutRoute = '/start' | '/mrnyc';

export const DEFAULT_LOGOUT_ROUTE: LogoutRoute = '/start';
const LOGOUT_ROUTE_KEY = 'linkPortalLogoutRoute';

interface RouteStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

function browserStorage(): RouteStorage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function isLogoutRoute(value: string | null): value is LogoutRoute {
  return value === '/start' || value === '/mrnyc';
}

export function getStoredLogoutRoute(
  storage: RouteStorage | null = browserStorage(),
): LogoutRoute {
  if (!storage) return DEFAULT_LOGOUT_ROUTE;
  try {
    const route = storage.getItem(LOGOUT_ROUTE_KEY);
    return isLogoutRoute(route) ? route : DEFAULT_LOGOUT_ROUTE;
  } catch {
    return DEFAULT_LOGOUT_ROUTE;
  }
}

export function storeLogoutRoute(
  route: LogoutRoute,
  storage: RouteStorage | null = browserStorage(),
): void {
  if (!storage) return;
  try {
    storage.setItem(LOGOUT_ROUTE_KEY, route);
  } catch {
    // Login can continue when browser storage is unavailable.
  }
}

export function clearStoredLogoutRoute(
  storage: RouteStorage | null = browserStorage(),
): void {
  if (!storage) return;
  try {
    storage.removeItem(LOGOUT_ROUTE_KEY);
  } catch {
    // Auth cleanup should continue when browser storage is unavailable.
  }
}
